import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { blueGrey } from "@mui/material/colors";
import FilePresentIcon from "@mui/icons-material/FilePresent";

export default function ButtonSelectCover() {
	const { register } = useFormContext();
	const [cover, setCover] = useState(null);
	return (
		<Box
			display={"flex"}
			flexDirection={"row"}
			justifyContent={"space-between"}
			alignItems={"center"}
		>
			<Button
				variant="contained"
				color="primary"
				size="small"
				component="label"
				startIcon={<FilePresentIcon />}
				sx={{ height: "fit-content" }}
			>
				<input
					style={{ width: 0 }}
					type="file"
					accept=".png"
					{...register("cover")}
					onChange={(e) =>
						setCover(URL.createObjectURL(e.target.files[0]))
					}
				/>
				Choisir une image
			</Button>
			{cover && (
				<Paper
					elevation={5}
					sx={{
						border: 3,
						borderColor: blueGrey[200],
						width: "10%",
					}}
				>
					<img
						alt="illustration"
						src={cover}
						width={"100%"}
					/>
				</Paper>
			)}
		</Box>
	);
}
